import { MetadataJson } from 'libphonenumber-js/core';

export default {
    version: 4,
    country_calling_codes: {
        '1': ['US'],
        '01': ['CA'],
        '7': ['RU'],
        '27': ['ZA'],
        '30': ['GR'],
        '31': ['NL'],
        '32': ['BE'],
        '33': ['FR'],
        '34': ['ES'],
        '36': ['HU'],
        '39': ['IT'],
        '40': ['RO'],
        '41': ['CH'],
        '43': ['AT'],
        '44': ['GB'],
        '45': ['DK'],
        '46': ['SE'],
        '47': ['NO'],
        '48': ['PL'],
        '49': ['DE'],
        '52': ['MX'],
        '55': ['BR'],
        '56': ['CL'],
        '60': ['MY'],
        '61': ['AU'],
        '62': ['ID'],
        '63': ['PH'],
        '64': ['NZ'],
        '65': ['SG'],
        '66': ['TH'],
        '81': ['JP'],
        '82': ['KR'],
        '84': ['VN'],
        '86': ['CN'],
        '90': ['TR'],
        '91': ['IN'],
        '358': ['FI'],
        '420': ['CZ'],
        '852': ['HK'],
        '853': ['MO'],
        '886': ['TW'],
        '965': ['KW'],
        '966': ['SA'],
        '971': ['AE'],
        '972': ['IL'],
        '974': ['QA']
    },
    countries: {
        AE: [
            '971',
            '00',
            '(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}',
            [5, 6, 7, 8, 9, 10, 11, 12],
            [
                ['(\\d{3})(\\d{2,9})', '$1 $2', ['60|8']],
                ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['[236]|[479][2-8]'], '0$1'],
                ['(\\d{3})(\\d)(\\d{5})', '$1 $2 $3', ['[479]']],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['5'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['[2-4679][2-8]\\d{6}', [8]],
                ['5[024-68]\\d{7}', [9]],
                ['400\\d{6}|800\\d{2,9}'],
                ['900[02]\\d{5}', [9]],
                0,
                0,
                ['600[25]\\d{5}', [9]],
                0,
                0,
                ['700[05]\\d{5}', [9]]
            ]
        ],
        AT: [
            '43',
            '00',
            '1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}',
            [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            [
                ['(\\d)(\\d{3,12})', '$1 $2', ['1(?:11|[2-9])'], '0$1'],
                ['(\\d{3})(\\d{2})', '$1 $2', ['517'], '0$1'],
                ['(\\d{2})(\\d{3,5})', '$1 $2', ['5[079]'], '0$1'],
                [
                    '(\\d{3})(\\d{3,10})',
                    '$1 $2',
                    ['(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]'],
                    '0$1'
                ],
                ['(\\d{4})(\\d{3,9})', '$1 $2', ['[2-467]|5[2-6]'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['5'], '0$1'],
                ['(\\d{2})(\\d{4})(\\d{4,7})', '$1 $2 $3', ['5'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}'
                ],
                ['6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}', [7, 8, 9, 10, 11, 12, 13]],
                ['800\\d{6,10}', [9, 10, 11, 12, 13]],
                ['(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}', [9, 10, 11, 12, 13]],
                0,
                0,
                0,
                0,
                [
                    '5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}',
                    [5, 6, 7, 8, 9, 10, 11, 12, 13]
                ],
                ['8(?:10|2[018])\\d{6,10}|828\\d{5}', [8, 9, 10, 11, 12, 13]]
            ]
        ],
        AU: [
            '61',
            '001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011',
            '1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}',
            [5, 6, 7, 8, 9, 10, 12],
            [
                ['(\\d{2})(\\d{3,4})', '$1 $2', ['16'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{2,4})', '$1 $2 $3', ['16'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['14|4'], '0$1'],
                ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['[2378]'], '(0$1)'],
                ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1(?:30|[89])']]
            ],
            '0',
            0,
            '(183[12])|0',
            0,
            0,
            0,
            [
                [
                    '(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}',
                    [9]
                ],
                [
                    '4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}',
                    [9]
                ],
                ['180(?:0\\d{3}|2)\\d{3}', [7, 10]],
                ['190[0-26]\\d{6}', [10]],
                0,
                0,
                0,
                ['163\\d{2,6}', [5, 6, 7, 8, 9]],
                ['14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}', [9]],
                ['13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}', [6, 8, 10, 12]]
            ],
            '0011'
        ],
        BE: [
            '32',
            '00',
            '4\\d{8}|[1-9]\\d{7}',
            [8, 9],
            [
                ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['(?:80|9)0'], '0$1'],
                ['(\\d)(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[239]|4[23]'], '0$1'],
                ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[15-8]'], '0$1'],
                ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['4'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}',
                    [8]
                ],
                ['4[5-9]\\d{7}', [9]],
                ['800[1-9]\\d{4}', [8]],
                ['(?:70(?:2[0-57]|3[04-7]|44|6[4-69]|7[0579])|90\\d\\d)\\d{4}', [8]],
                0,
                0,
                ['78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}', [8]],
                0,
                0,
                ['7879\\d{4}', [8]]
            ]
        ],
        BR: [
            '55',
            '00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)',
            '(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}',
            [8, 9, 10, 11],
            [
                ['(\\d{4})(\\d{4})', '$1-$2', ['300|4(?:0[02]|37)', '4(?:02|37)0|[34]00']],
                ['(\\d{3})(\\d{2,3})(\\d{4})', '$1 $2 $3', ['(?:[358]|90)0'], '0$1'],
                [
                    '(\\d{2})(\\d{4})(\\d{4})',
                    '$1 $2-$3',
                    ['(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]'],
                    '($1)'
                ],
                ['(\\d{2})(\\d{5})(\\d{4})', '$1 $2-$3', ['[16][1-9]|[2-57-9]'], '($1)']
            ],
            '0',
            0,
            '(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?',
            '$2',
            0,
            0,
            [
                ['(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}', [10]],
                ['(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}', [10, 11]],
                ['800\\d{6,7}', [9, 10]],
                ['300\\d{6}|[59]00\\d{6,7}', [9, 10]],
                0,
                0,
                0,
                0,
                0,
                ['(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}', [8, 10]]
            ]
        ],
        CA: [
            '1',
            '011',
            '(?:[2-8]\\d|90)\\d{8}|3\\d{6}',
            [7, 10],
            0,
            '1',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}',
                    [10]
                ],
                ['', [10]],
                ['8(?:00|33|44|55|66|77|88)[2-9]\\d{6}', [10]],
                ['900[2-9]\\d{6}', [10]],
                [
                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}',
                    [10]
                ],
                0,
                ['310\\d{4}', [7]],
                0,
                ['600[2-9]\\d{6}', [10]]
            ]
        ],
        CH: [
            '41',
            '00',
            '8\\d{11}|[2-9]\\d{8}',
            [9],
            [
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8[047]|90'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-79]|81'], '0$1'],
                ['(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4 $5', ['8'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}'],
                ['7[35-9]\\d{7}'],
                ['800\\d{6}'],
                ['90[016]\\d{6}'],
                ['878\\d{6}'],
                0,
                ['5[18]\\d{7}'],
                ['74[0248]\\d{6}'],
                0,
                ['84[0248]\\d{6}']
            ]
        ],
        CL: [
            '56',
            '(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0',
            '12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}',
            [9, 10, 11],
            [
                ['(\\d{5})(\\d{4})', '$1 $2', ['219', '2196'], '($1)'],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['44']],
                ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['2[1-36]'], '($1)'],
                ['(\\d)(\\d{4})(\\d{4})', '$1 $2 $3', ['9[2-9]']],
                [
                    '(\\d{2})(\\d{3})(\\d{4})',
                    '$1 $2 $3',
                    ['3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])'],
                    '($1)'
                ],
                ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['60|8']],
                ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']],
                ['(\\d{3})(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3 $4', ['60']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}',
                    [9]
                ],
                ['', [9]],
                ['(?:123|8)00\\d{6}', [9, 11]],
                0,
                0,
                0,
                0,
                0,
                ['44\\d{7}', [9]],
                ['600\\d{7,8}', [10, 11]]
            ]
        ],
        CN: [
            '86',
            '00|1(?:[12]\\d|79)\\d\\d00',
            '1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}',
            [7, 8, 9, 10, 11, 12],
            [
                [
                    '(\\d{2})(\\d{5,6})',
                    '$1 $2',
                    [
                        '(?:10|2[0-57-9])[19]',
                        '(?:10|2[0-57-9])(?:10|9[56])',
                        '10(?:10|9[56])|2[0-57-9](?:100|9[56])'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{5,6})',
                    '$1 $2',
                    [
                        '3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]',
                        '(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]',
                        '85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])',
                        '85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])'
                    ],
                    '0$1'
                ],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['(?:4|80)0']],
                [
                    '(\\d{2})(\\d{4})(\\d{4})',
                    '$1 $2 $3',
                    [
                        '10|2(?:[02-57-9]|1[1-9])',
                        '10|2(?:[02-57-9]|1[1-9])',
                        '10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])'
                    ],
                    '0$1',
                    1
                ],
                [
                    '(\\d{3})(\\d{3})(\\d{4})',
                    '$1 $2 $3',
                    [
                        '3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]'
                    ],
                    '0$1',
                    1
                ],
                ['(\\d{3})(\\d{7,8})', '$1 $2', ['9']],
                ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['80'], '0$1', 1],
                ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['[3-578]'], '0$1', 1],
                ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['1[3-9]']],
                ['(\\d{2})(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3 $4', ['[12]'], '0$1', 1]
            ],
            '0',
            0,
            '(1(?:[12]\\d|79)\\d\\d)|0',
            0,
            0,
            0,
            [
                [
                    '(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))',
                    [7, 8, 9, 10, 11]
                ],
                ['1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}', [11]],
                ['(?:(?:10|21)8|8)00\\d{7}', [10, 12]],
                ['16[08]\\d{5}', [8]],
                0,
                0,
                0,
                0,
                0,
                [
                    '10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}',
                    [7, 8, 9, 10, 11]
                ]
            ],
            '00'
        ],
        CZ: [
            '420',
            '00',
            '(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}',
            [9],
            [
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[2-8]|9[015-7]']],
                ['(\\d{2})(\\d{3})(\\d{3})(\\d{2})', '$1 $2 $3 $4', ['96']],
                ['(\\d{2})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9']],
                ['(\\d{3})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                ['(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}'],
                ['(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}'],
                ['800\\d{6}'],
                ['9(?:0[05689]|76)\\d{6}'],
                ['70[01]\\d{6}'],
                0,
                ['9(?:5\\d|7[2-4])\\d{6}'],
                0,
                ['9[17]0\\d{6}'],
                ['8[134]\\d{7}']
            ]
        ],
        DE: [
            '49',
            '00',
            '[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}',
            [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            [
                ['(\\d{2})(\\d{3,13})', '$1 $2', ['3[02]|40|[68]9'], '0$1'],
                [
                    '(\\d{3})(\\d{3,12})',
                    '$1 $2',
                    [
                        '2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1',
                        '2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{4})(\\d{2,11})',
                    '$1 $2',
                    [
                        '[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]',
                        '[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]'
                    ],
                    '0$1'
                ],
                ['(\\d{3})(\\d{4})', '$1 $2', ['138'], '0$1'],
                ['(\\d{5})(\\d{2,10})', '$1 $2', ['3'], '0$1'],
                ['(\\d{3})(\\d{5,11})', '$1 $2', ['181'], '0$1'],
                ['(\\d{3})(\\d)(\\d{4,10})', '$1 $2 $3', ['1(?:3|80)|9'], '0$1'],
                ['(\\d{3})(\\d{7,8})', '$1 $2', ['1[67]'], '0$1'],
                ['(\\d{3})(\\d{7,12})', '$1 $2', ['8'], '0$1'],
                ['(\\d{5})(\\d{6})', '$1 $2', ['185', '1850', '18500'], '0$1'],
                ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['7'], '0$1'],
                ['(\\d{4})(\\d{7})', '$1 $2', ['18[68]'], '0$1'],
                ['(\\d{5})(\\d{6})', '$1 $2', ['15[0568]'], '0$1'],
                ['(\\d{4})(\\d{7})', '$1 $2', ['15[1279]'], '0$1'],
                ['(\\d{3})(\\d{8})', '$1 $2', ['18'], '0$1'],
                ['(\\d{3})(\\d{2})(\\d{7,8})', '$1 $2 $3', ['1(?:6[023]|7)'], '0$1'],
                ['(\\d{4})(\\d{2})(\\d{7})', '$1 $2 $3', ['15[279]'], '0$1'],
                ['(\\d{3})(\\d{2})(\\d{8})', '$1 $2 $3', ['15'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}',
                    [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
                ],
                ['15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}', [10, 11]],
                ['800\\d{7,12}', [10, 11, 12, 13, 14, 15]],
                ['(?:137[7-9]|900(?:[135]|9\\d))\\d{6}', [10, 11]],
                ['700\\d{8}', [11]],
                0,
                ['18(?:1\\d{5,11}|[2-9]\\d{8})', [8, 9, 10, 11, 12, 13, 14]],
                ['16(?:4\\d{1,10}|[89]\\d{1,11})', [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]],
                0,
                ['180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}', [7, 8, 9, 10, 11, 12, 13, 14]]
            ]
        ],
        DK: [
            '45',
            '00',
            '[2-9]\\d{7}',
            [8],
            [['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-9]']]],
            0,
            0,
            0,
            0,
            0,
            0,
            [['(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}'], [''], ['80\\d{6}'], ['90\\d{6}']]
        ],
        ES: [
            '34',
            '00',
            '[5-9]\\d{8}',
            [9],
            [
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[89]00']],
                ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[5-9]']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}'
                ],
                ['(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}'],
                ['[89]00\\d{6}'],
                ['80[367]\\d{6}'],
                ['70\\d{7}'],
                0,
                ['51\\d{7}'],
                0,
                0,
                ['90[12]\\d{6}']
            ]
        ],
        FI: [
            '358',
            '00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))',
            '[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}',
            [5, 6, 7, 8, 9, 10, 11, 12],
            [
                ['(\\d)(\\d{4,9})', '$1 $2', ['[2568][1-8]|3(?:0[1-9]|[1-9])|9'], '0$1'],
                ['(\\d{3})(\\d{3,7})', '$1 $2', ['[12]00|[368]|70[07-9]'], '0$1'],
                ['(\\d{2})(\\d{4,8})', '$1 $2', ['[1245]|7[135]'], '0$1'],
                ['(\\d{2})(\\d{6,10})', '$1 $2', ['7'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            '1[03-79]|[2-9]',
            [
                ['(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}', [5, 6, 7, 8, 9]],
                ['4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}', [6, 7, 8, 9, 10]],
                ['800\\d{4,6}', [7, 8, 9]],
                ['[67]00\\d{5,6}', [8, 9]],
                0,
                0,
                [
                    '20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}'
                ]
            ],
            '00'
        ],
        FR: [
            '33',
            '00',
            '[1-9]\\d{8}',
            [9],
            [
                ['(\\d{3})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['8'], '0 $1'],
                ['(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4 $5', ['[1-79]'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['59[1-9]\\d{6}|(?:[1-3]\\d|4[1-9]|5[0-8])\\d{7}'],
                ['(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}'],
                ['80[0-5]\\d{6}'],
                [
                    '836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}'
                ],
                0,
                0,
                ['80[6-9]\\d{6}'],
                0,
                ['9\\d{8}'],
                ['8(?:1[01]|2[0156]|4[02]|84)\\d{6}']
            ]
        ],
        GB: [
            '44',
            '00',
            '[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}',
            [7, 9, 10],
            [
                ['(\\d{3})(\\d{4})', '$1 $2', ['800', '8001', '80011', '800111', '8001111'], '0$1'],
                ['(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3', ['845', '8454', '84546', '845464'], '0$1'],
                ['(\\d{3})(\\d{6})', '$1 $2', ['800'], '0$1'],
                [
                    '(\\d{5})(\\d{4,5})',
                    '$1 $2',
                    [
                        '1(?:38|5[23]|69|76|94)',
                        '1(?:(?:38|69)7|5(?:24|39)|768|946)',
                        '1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)'
                    ],
                    '0$1'
                ],
                ['(\\d{4})(\\d{5,6})', '$1 $2', ['1(?:[2-69][02-9]|[78])'], '0$1'],
                [
                    '(\\d{2})(\\d{4})(\\d{4})',
                    '$1 $2 $3',
                    ['[25]|7(?:0|6[02-9])', '[25]|7(?:0|6(?:[03-9]|2[356]))'],
                    '0$1'
                ],
                ['(\\d{4})(\\d{6})', '$1 $2', ['7'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1389]'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}',
                    [9, 10]
                ],
                [
                    '7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}',
                    [10]
                ],
                ['80[08]\\d{7}|800\\d{6}|8001111'],
                ['(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d', [7, 10]],
                ['70\\d{8}', [10]],
                0,
                ['(?:3[0347]|55)\\d{8}', [10]],
                [
                    '76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}',
                    [10]
                ],
                ['56\\d{8}', [10]]
            ],
            0,
            ' x'
        ],
        GR: [
            '30',
            '00',
            '5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}',
            [10, 11, 12],
            [
                ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['21|7']],
                [
                    '(\\d{4})(\\d{6})',
                    '$1 $2',
                    ['2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5']
                ],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[2689]']],
                ['(\\d{3})(\\d{3,4})(\\d{5})', '$1 $2 $3', ['8']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}',
                    [10]
                ],
                ['68[57-9]\\d{7}|(?:69|94)\\d{8}', [10]],
                ['800\\d{7,9}'],
                ['90[19]\\d{7}', [10]],
                ['70\\d{8}', [10]],
                0,
                ['5005000\\d{3}', [10]],
                0,
                0,
                ['8(?:0[16]|12|[27]5|50)\\d{7}', [10]]
            ]
        ],
        HK: [
            '852',
            '00(?:30|5[09]|[126-9]?)',
            '8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}',
            [5, 6, 7, 8, 9, 11],
            [
                ['(\\d{3})(\\d{2,5})', '$1 $2', ['900', '9003']],
                ['(\\d{4})(\\d{4})', '$1 $2', ['[2-7]|8[1-4]|9(?:0[1-9]|[1-8])']],
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8']],
                ['(\\d{3})(\\d{2})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['9']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[59]\\d|6[01]))|58(?:0[1-9]|1[2-9]))\\d{4}',
                    [8]
                ],
                [
                    '(?:4(?:44[5-9]|6(?:1[0-7]|4[0-57-9]|6[0-4]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3])|70(?:7[1-6]|8[0-4])|848[0-25-9]|9(?:29[013-9]|59[0-4]|899))\\d{4}|(?:4(?:4[015]|6[02357-9])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}',
                    [8]
                ],
                ['800\\d{6}', [9]],
                ['900(?:[0-24-9]\\d{7}|3\\d{1,4})', [5, 6, 7, 8, 11]],
                ['8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}', [8]],
                0,
                ['30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}', [8]],
                [
                    '7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}',
                    [8]
                ]
            ],
            '00'
        ],
        HU: [
            '36',
            '00',
            '[235-7]\\d{8}|[1-9]\\d{7}',
            [8, 9],
            [
                ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '(06 $1)'],
                [
                    '(\\d{2})(\\d{3})(\\d{3})',
                    '$1 $2 $3',
                    ['[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]'],
                    '(06 $1)'
                ],
                ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[2-9]'], '06 $1']
            ],
            '06',
            0,
            0,
            0,
            0,
            0,
            [
                ['(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}', [8]],
                ['(?:[257]0|3[01])\\d{7}', [9]],
                ['(?:[48]0\\d|680[29])\\d{5}'],
                ['9[01]\\d{6}', [8]],
                0,
                0,
                ['38\\d{7}', [9]],
                0,
                ['21\\d{7}', [9]]
            ]
        ],
        ID: [
            '62',
            '00',
            '(?:8[1-9])\\d{7,10}',
            [9, 10, 11, 12],
            [
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['8'], '0$1'],
                ['(\\d{3})(\\d{4})(\\d{3})', '$1 $2 $3', ['8'], '0$1'],
                ['(\\d{3})(\\d{4})(\\d{4})', '$1 $2 $3', ['8'], '0$1'],
                ['(\\d{3})(\\d{4})(\\d{5})', '$1 $2 $3', ['8'], '0$1'],
                ['(\\d{3})(\\d{4})(\\d{6})', '$1 $2 $3', ['8'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            []
        ],
        IL: [
            '972',
            '0(?:0|1[2-9])',
            '1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}',
            [7, 8, 9, 10, 11, 12],
            [
                ['(\\d{4})(\\d{3})', '$1-$2', ['125']],
                ['(\\d{4})(\\d{2})(\\d{2})', '$1-$2-$3', ['121']],
                ['(\\d)(\\d{3})(\\d{4})', '$1-$2-$3', ['[2-489]'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['[57]'], '0$1'],
                ['(\\d{4})(\\d{3})(\\d{3})', '$1-$2-$3', ['12']],
                ['(\\d{4})(\\d{6})', '$1-$2', ['159']],
                ['(\\d)(\\d{3})(\\d{3})(\\d{3})', '$1-$2-$3-$4', ['1[7-9]']],
                ['(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})', '$1-$2 $3-$4', ['15']]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}', [8, 11, 12]],
                [
                    '55410\\d{4}|5(?:(?:[02][02-9]|[149][2-9]|[36]\\d|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}',
                    [9]
                ],
                ['1(?:255|80[019]\\d{3})\\d{3}', [7, 10]],
                ['1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}', [8, 10]],
                0,
                0,
                ['1599\\d{6}', [10]],
                0,
                [
                    '7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}',
                    [9]
                ],
                ['1700\\d{6}', [10]]
            ]
        ],
        IN: [
            '91',
            '00',
            '(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}',
            [8, 9, 10, 11, 12, 13],
            [
                [
                    '(\\d{8})',
                    '$1',
                    [
                        '5(?:0|2[23]|3[03]|[67]1|88)',
                        '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)',
                        '5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)'
                    ],
                    0,
                    1
                ],
                ['(\\d{4})(\\d{4,5})', '$1 $2', ['180', '1800'], 0, 1],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['140'], 0, 1],
                [
                    '(\\d{2})(\\d{4})(\\d{4})',
                    '$1 $2 $3',
                    [
                        '11|2[02]|33|4[04]|79[1-7]|80[2-46]',
                        '11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])',
                        '11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])'
                    ],
                    '0$1',
                    1
                ],
                [
                    '(\\d{3})(\\d{3})(\\d{4})',
                    '$1 $2 $3',
                    [
                        '1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]',
                        '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]',
                        '1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]'
                    ],
                    '0$1',
                    1
                ],
                [
                    '(\\d{4})(\\d{3})(\\d{3})',
                    '$1 $2 $3',
                    [
                        '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807',
                        '1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]',
                        '1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]'
                    ],
                    '0$1',
                    1
                ],
                ['(\\d{5})(\\d{5})', '$1 $2', ['[6-9]'], '0$1', 1],
                ['(\\d{4})(\\d{2,4})(\\d{4})', '$1 $2 $3', ['1(?:6|8[06])', '1(?:6|8[06]0)'], 0, 1],
                ['(\\d{4})(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['18'], 0, 1]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}',
                    [10]
                ],
                [
                    '(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}',
                    [10]
                ],
                ['000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))'],
                ['186[12]\\d{9}', [13]],
                0,
                0,
                ['140\\d{7}', [10]],
                0,
                0,
                ['1860\\d{7}', [11]]
            ]
        ],
        IT: [
            '39',
            '00',
            '0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?',
            [6, 7, 8, 9, 10, 11],
            [
                ['(\\d{2})(\\d{4,6})', '$1 $2', ['0[26]']],
                [
                    '(\\d{3})(\\d{3,6})',
                    '$1 $2',
                    [
                        '0[13-57-9][0159]|8(?:03|4[17]|9[2-5])',
                        '0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))'
                    ]
                ],
                ['(\\d{4})(\\d{2,6})', '$1 $2', ['0(?:[13-579][2-46-8]|8[236-8])']],
                ['(\\d{4})(\\d{4})', '$1 $2', ['894']],
                ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['0[26]|5']],
                ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['1(?:44|[679])|[378]']],
                ['(\\d{3})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['0[13-57-9][0159]|14']],
                ['(\\d{2})(\\d{4})(\\d{5})', '$1 $2 $3', ['0[26]']],
                ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['0']],
                ['(\\d{3})(\\d{4})(\\d{4,5})', '$1 $2 $3', ['3']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}'
                ],
                ['3[1-9]\\d{8}|3[2-9]\\d{7}', [9, 10]],
                ['80(?:0\\d{3}|3)\\d{3}', [6, 9]],
                [
                    '(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}',
                    [6, 8, 9, 10]
                ],
                ['1(?:78\\d|99)\\d{6}', [9, 10]],
                0,
                0,
                0,
                ['55\\d{8}', [10]],
                ['84(?:[08]\\d{3}|[17])\\d{3}', [6, 9]]
            ]
        ],
        JP: [
            '81',
            '010',
            '00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}',
            [8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
            [
                ['(\\d{3})(\\d{3})(\\d{3})', '$1-$2-$3', ['(?:12|57|99)0'], '0$1'],
                [
                    '(\\d{4})(\\d)(\\d{4})',
                    '$1-$2-$3',
                    [
                        '1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])',
                        '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]',
                        '1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]'
                    ],
                    '0$1'
                ],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['60'], '0$1'],
                [
                    '(\\d)(\\d{4})(\\d{4})',
                    '$1-$2-$3',
                    ['[36]|4(?:2[09]|7[01])', '[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))'],
                    '0$1'
                ],
                [
                    '(\\d{2})(\\d{3})(\\d{4})',
                    '$1-$2-$3',
                    [
                        '1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])',
                        '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]',
                        '1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]'
                    ],
                    '0$1'
                ],
                [
                    '(\\d{3})(\\d{2})(\\d{4})',
                    '$1-$2-$3',
                    ['[14]|[289][2-9]|5[3-9]|7[2-4679]'],
                    '0$1'
                ],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2-$3', ['800'], '0$1'],
                ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2-$3', ['[257-9]'], '0$1']
            ],
            '0',
            0,
            '(000[259]\\d{6})$|(?:(?:003768)0?)|0',
            '$1',
            0,
            0,
            [
                [
                    '(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}',
                    [9]
                ],
                ['[7-9]0[1-9]\\d{7}', [10]],
                [
                    '00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}'
                ],
                ['990\\d{6}', [9]],
                ['60\\d{7}', [9]],
                0,
                ['570\\d{6}', [9]],
                ['20\\d{8}', [10]],
                ['50[1-9]\\d{7}', [10]]
            ]
        ],
        KR: [
            '82',
            '00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))',
            '00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}',
            [5, 6, 8, 9, 10, 11, 12, 13, 14],
            [
                ['(\\d{2})(\\d{3,4})', '$1-$2', ['(?:3[1-3]|[46][1-4]|5[1-5])1'], '0$1'],
                ['(\\d{4})(\\d{4})', '$1-$2', ['1']],
                ['(\\d)(\\d{3,4})(\\d{4})', '$1-$2-$3', ['2'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1-$2-$3', ['60|8'], '0$1'],
                ['(\\d{2})(\\d{3,4})(\\d{4})', '$1-$2-$3', ['[1346]|5[1-5]'], '0$1'],
                ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2-$3', ['[57]'], '0$1'],
                ['(\\d{2})(\\d{5})(\\d{4})', '$1-$2-$3', ['5'], '0$1']
            ],
            '0',
            0,
            '0(8(?:[1-46-8]|5\\d\\d))?',
            0,
            0,
            0,
            [
                [
                    '(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}',
                    [5, 6, 8, 9, 10]
                ],
                [
                    '1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}',
                    [9, 10]
                ],
                ['00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}', [9, 11, 12, 13, 14]],
                ['60[2-9]\\d{6}', [9]],
                ['50\\d{8,9}', [10, 11]],
                0,
                [
                    '1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}',
                    [8]
                ],
                ['15\\d{7,8}', [9, 10]],
                ['70\\d{8}', [10]]
            ]
        ],
        KW: [
            '965',
            '00',
            '18\\d{5}|(?:[2569]\\d|41)\\d{6}',
            [7, 8],
            [
                ['(\\d{4})(\\d{3,4})', '$1 $2', ['[169]|2(?:[235]|4[1-35-9])|52']],
                ['(\\d{3})(\\d{5})', '$1 $2', ['[245]']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}',
                    [8]
                ],
                [
                    '(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}',
                    [8]
                ],
                ['18\\d{5}', [7]]
            ]
        ],
        MO: [
            '853',
            '00',
            '0800\\d{3}|(?:28|[68]\\d)\\d{6}',
            [7, 8],
            [
                ['(\\d{4})(\\d{3})', '$1 $2', ['0']],
                ['(\\d{4})(\\d{4})', '$1 $2', ['[268]']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                ['(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}', [8]],
                [
                    '6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}',
                    [8]
                ],
                ['0800\\d{3}', [7]]
            ]
        ],
        MX: [
            '52',
            '0[09]',
            '1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}',
            [10, 11],
            [
                ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['33|5[56]|81'], 0, 1],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['[2-9]'], 0, 1],
                ['(\\d)(\\d{2})(\\d{4})(\\d{4})', '$2 $3 $4', ['1(?:33|5[56]|81)'], 0, 1],
                ['(\\d)(\\d{3})(\\d{3})(\\d{4})', '$2 $3 $4', ['1'], 0, 1]
            ],
            '01',
            0,
            '0(?:[12]|4[45])|1',
            0,
            0,
            0,
            [
                [
                    '657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}',
                    [10]
                ],
                [
                    '657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}'
                ],
                ['8(?:00|88)\\d{7}', [10]],
                ['900\\d{7}', [10]],
                ['500\\d{7}', [10]],
                0,
                0,
                0,
                0,
                ['300\\d{7}', [10]]
            ],
            '00'
        ],
        MY: [
            '60',
            '00',
            '1\\d{8,9}|(?:3\\d|[4-9])\\d{7}',
            [8, 9, 10],
            [
                ['(\\d)(\\d{3})(\\d{4})', '$1-$2 $3', ['[4-79]'], '0$1'],
                [
                    '(\\d{2})(\\d{3})(\\d{3,4})',
                    '$1-$2 $3',
                    [
                        '1(?:[02469]|[378][1-9]|53)|8',
                        '1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8'
                    ],
                    '0$1'
                ],
                ['(\\d)(\\d{4})(\\d{4})', '$1-$2 $3', ['3'], '0$1'],
                ['(\\d)(\\d{3})(\\d{2})(\\d{4})', '$1-$2-$3-$4', ['1(?:[367]|80)']],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1-$2 $3', ['15'], '0$1'],
                ['(\\d{2})(\\d{4})(\\d{4})', '$1-$2 $3', ['1'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}',
                    [8, 9]
                ],
                [
                    '1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}',
                    [9, 10]
                ],
                ['1[378]00\\d{6}', [10]],
                ['1600\\d{6}', [10]],
                0,
                0,
                0,
                0,
                [
                    '15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}',
                    [10]
                ]
            ]
        ],
        NL: [
            '31',
            '00',
            '(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}',
            [5, 6, 7, 8, 9, 10, 11],
            [
                ['(\\d{3})(\\d{4,7})', '$1 $2', ['[89]0'], '0$1'],
                ['(\\d{2})(\\d{7})', '$1 $2', ['66'], '0$1'],
                ['(\\d)(\\d{8})', '$1 $2', ['6'], '0$1'],
                [
                    '(\\d{3})(\\d{3})(\\d{3})',
                    '$1 $2 $3',
                    ['1[16-8]|2[259]|3[124]|4[17-9]|5[124679]'],
                    '0$1'
                ],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1-578]|91'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{5})', '$1 $2 $3', ['9'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}',
                    [9]
                ],
                ['(?:6[1-58]|970\\d)\\d{7}', [9, 11]],
                ['800\\d{4,7}', [7, 8, 9, 10]],
                ['90[069]\\d{4,7}', [7, 8, 9, 10]],
                0,
                0,
                [
                    '140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d',
                    [5, 6, 9]
                ],
                ['66\\d{7}', [9]],
                ['(?:85|91)\\d{7}', [9]]
            ]
        ],
        NO: [
            '47',
            '00',
            '(?:0|[2-9]\\d{3})\\d{4}',
            [5, 8],
            [
                ['(\\d{3})(\\d{2})(\\d{3})', '$1 $2 $3', ['8']],
                ['(\\d{2})(\\d{2})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['[2-79]']]
            ],
            0,
            0,
            0,
            0,
            0,
            '[02-689]|7[0-8]',
            [
                ['(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}', [8]],
                ['(?:4[015-8]|9\\d)\\d{6}', [8]],
                ['80[01]\\d{5}', [8]],
                ['82[09]\\d{5}', [8]],
                ['880\\d{5}', [8]],
                0,
                ['(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}'],
                0,
                ['85[0-5]\\d{5}', [8]],
                ['810(?:0[0-6]|[2-8]\\d)\\d{3}', [8]]
            ]
        ],
        NZ: [
            '64',
            '0(?:0|161)',
            '[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}',
            [5, 6, 7, 8, 9, 10],
            [
                ['(\\d{2})(\\d{3,8})', '$1 $2', ['8[1-79]'], '0$1'],
                [
                    '(\\d{3})(\\d{2})(\\d{2,3})',
                    '$1 $2 $3',
                    ['50[036-8]|8|90', '50(?:[0367]|88)|8|90'],
                    '0$1'
                ],
                ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['24|[346]|7[2-57-9]|9[2-9]'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['2(?:10|74)|[589]'], '0$1'],
                ['(\\d{2})(\\d{3,4})(\\d{4})', '$1 $2 $3', ['1|2[028]'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{3,5})', '$1 $2 $3', ['2(?:[169]|7[0-35-9])|7'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}', [8]],
                ['2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}', [8, 9, 10]],
                ['508\\d{6,7}|80\\d{6,8}', [8, 9, 10]],
                ['(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}', [7, 8, 9, 10]],
                ['70\\d{7}', [9]],
                0,
                ['8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}']
            ],
            '00'
        ],
        PL: [
            '48',
            '00',
            '(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}',
            [6, 7, 8, 9, 10],
            [
                ['(\\d{5})', '$1', ['19']],
                ['(\\d{3})(\\d{3})', '$1 $2', ['11|20|64']],
                [
                    '(\\d{2})(\\d{2})(\\d{3})',
                    '$1 $2 $3',
                    [
                        '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1',
                        '(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19'
                    ]
                ],
                ['(\\d{3})(\\d{2})(\\d{2,3})', '$1 $2 $3', ['64']],
                [
                    '(\\d{3})(\\d{3})(\\d{3})',
                    '$1 $2 $3',
                    ['21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)']
                ],
                [
                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    ['1[2-8]|[2-7]|8[1-79]|9[145]']
                ],
                ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['8']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))',
                    [7, 9]
                ],
                [
                    '21(?:1(?:[145]\\d|3[1-5])|2\\d\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}',
                    [9]
                ],
                ['800\\d{6,7}', [9, 10]],
                ['70[01346-8]\\d{6}', [9]],
                0,
                0,
                ['804\\d{6}', [9]],
                ['64\\d{4,7}', [6, 7, 8, 9]],
                ['39\\d{7}', [9]],
                ['801\\d{6}', [9]]
            ]
        ],
        QA: [
            '974',
            '00',
            '800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}',
            [7, 8, 9, 11],
            [
                ['(\\d{3})(\\d{4})', '$1 $2', ['2[16]|8']],
                ['(\\d{4})(\\d{4})', '$1 $2', ['[3-7]']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                ['4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}', [8]],
                ['[35-7]\\d{7}', [8]],
                ['800\\d{4}|(?:0080[01]|800)\\d{6}', [7, 9, 11]],
                0,
                0,
                0,
                0,
                ['2[16]\\d{5}', [7]]
            ]
        ],
        RO: [
            '40',
            '00',
            '(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}',
            [6, 9],
            [
                ['(\\d{3})(\\d{3})', '$1 $2', ['2[3-6]', '2[3-6]\\d9'], '0$1'],
                ['(\\d{2})(\\d{4})', '$1 $2', ['219|31'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[23]1'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[236-9]'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d'],
                ['7020\\d{5}|(?:62\\d|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}', [9]],
                ['800\\d{6}', [9]],
                ['90[0136]\\d{6}', [9]],
                0,
                0,
                ['(?:37\\d|80[578])\\d{6}', [9]],
                0,
                0,
                ['801\\d{6}', [9]]
            ],
            0,
            ' int '
        ],
        RU: [
            '7',
            '810',
            '8\\d{13}|[347-9]\\d{9}',
            [10, 14],
            [
                [
                    '(\\d{4})(\\d{2})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    [
                        '7(?:1[0-8]|2[1-9])',
                        '7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))',
                        '7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2'
                    ],
                    '8 ($1)',
                    1
                ],
                [
                    '(\\d{5})(\\d)(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    [
                        '7(?:1[0-68]|2[1-9])',
                        '7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))',
                        '7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]'
                    ],
                    '8 ($1)',
                    1
                ],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['7'], '8 ($1)', 1],
                [
                    '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                    '$1 $2-$3-$4',
                    ['[349]|8(?:[02-7]|1[1-8])'],
                    '8 ($1)',
                    1
                ],
                ['(\\d{4})(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3 $4', ['8'], '8 ($1)']
            ],
            '8',
            0,
            0,
            0,
            0,
            '3[04-689]|[489]',
            [
                [
                    '(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}',
                    [10]
                ],
                ['9\\d{9}', [10]],
                ['8(?:0[04]|108\\d{3})\\d{7}'],
                ['80[39]\\d{7}', [10]],
                ['808\\d{7}', [10]]
            ],
            '8~10'
        ],
        SA: [
            '966',
            '00',
            '92\\d{7}|(?:[15]|8\\d)\\d{8}',
            [9, 10],
            [
                ['(\\d{4})(\\d{5})', '$1 $2', ['9']],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['1'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['5'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['81'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}', [9]],
                ['579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}', [9]],
                ['800\\d{7}', [10]],
                ['925\\d{6}', [9]],
                0,
                0,
                ['811\\d{7}', [10]],
                0,
                0,
                ['920\\d{6}', [9]]
            ]
        ],
        SE: [
            '46',
            '00',
            '(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}',
            [6, 7, 8, 9, 10],
            [
                ['(\\d{2})(\\d{2,3})(\\d{2})', '$1-$2 $3', ['20'], '0$1', 0, '$1 $2 $3'],
                ['(\\d{3})(\\d{4})', '$1-$2', ['9(?:00|39|44|9)'], '0$1', 0, '$1 $2'],
                [
                    '(\\d{2})(\\d{3})(\\d{2})',
                    '$1-$2 $3',
                    ['[12][136]|3[356]|4[0246]|6[03]|90[1-9]'],
                    '0$1',
                    0,
                    '$1 $2 $3'
                ],
                ['(\\d)(\\d{2,3})(\\d{2})(\\d{2})', '$1-$2 $3 $4', ['8'], '0$1', 0, '$1 $2 $3 $4'],
                [
                    '(\\d{3})(\\d{2,3})(\\d{2})',
                    '$1-$2 $3',
                    [
                        '1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'
                    ],
                    '0$1',
                    0,
                    '$1 $2 $3'
                ],
                ['(\\d{3})(\\d{2,3})(\\d{3})', '$1-$2 $3', ['9(?:00|39|44)'], '0$1', 0, '$1 $2 $3'],
                [
                    '(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})',
                    '$1-$2 $3 $4',
                    ['1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]'],
                    '0$1',
                    0,
                    '$1 $2 $3 $4'
                ],
                [
                    '(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                    '$1-$2 $3 $4',
                    ['10|7'],
                    '0$1',
                    0,
                    '$1 $2 $3 $4'
                ],
                ['(\\d)(\\d{3})(\\d{3})(\\d{2})', '$1-$2 $3 $4', ['8'], '0$1', 0, '$1 $2 $3 $4'],
                [
                    '(\\d{3})(\\d{2})(\\d{2})(\\d{2})',
                    '$1-$2 $3 $4',
                    [
                        '[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])'
                    ],
                    '0$1',
                    0,
                    '$1 $2 $3 $4'
                ],
                ['(\\d{3})(\\d{2})(\\d{2})(\\d{3})', '$1-$2 $3 $4', ['9'], '0$1', 0, '$1 $2 $3 $4'],
                [
                    '(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})',
                    '$1-$2 $3 $4 $5',
                    ['[26]'],
                    '0$1',
                    0,
                    '$1 $2 $3 $4 $5'
                ]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}',
                    [7, 8, 9]
                ],
                ['7[02369]\\d{7}', [9]],
                ['20\\d{4,7}', [6, 7, 8, 9]],
                ['649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}', [7, 8, 9, 10]],
                ['75[1-8]\\d{6}', [9]],
                0,
                ['10[1-8]\\d{6}', [9]],
                ['74[02-9]\\d{6}', [9]],
                0,
                ['77[0-7]\\d{6}', [9]]
            ]
        ],
        SG: [
            '65',
            '0[0-3]\\d',
            '(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}',
            [8, 10, 11],
            [
                ['(\\d{4})(\\d{4})', '$1 $2', ['[369]|8(?:0[1-8]|[1-9])']],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8']],
                ['(\\d{4})(\\d{4})(\\d{3})', '$1 $2 $3', ['7']],
                ['(\\d{4})(\\d{3})(\\d{4})', '$1 $2 $3', ['1']]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                ['662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}', [8]],
                ['8(?:08[013]|95[0-2])\\d{4}|(?:8(?:0[1-7]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}', [8]],
                ['(?:18|8)00\\d{7}', [10, 11]],
                ['1900\\d{7}', [11]],
                0,
                0,
                ['7000\\d{7}', [11]],
                0,
                ['(?:3[12]\\d|666)\\d{5}', [8]]
            ]
        ],
        TH: [
            '66',
            '00[1-9]',
            '(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}',
            [8, 9, 10, 13],
            [
                ['(\\d)(\\d{3})(\\d{4})', '$1 $2 $3', ['2'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[13-9]'], '0$1'],
                ['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['1']]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                ['(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}', [8]],
                ['671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}', [9]],
                ['(?:001800\\d|1800)\\d{6}', [10, 13]],
                ['1900\\d{6}', [10]],
                0,
                0,
                0,
                0,
                ['6[08]\\d{7}', [9]]
            ]
        ],
        TR: [
            '90',
            '00',
            '4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}',
            [7, 10, 12, 13],
            [
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['512|8[01589]|90'], '0$1', 1],
                [
                    '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    ['5(?:[0-59]|61)', '5(?:[0-59]|61[06])', '5(?:[0-59]|61[06]1)'],
                    '0$1',
                    1
                ],
                [
                    '(\\d{3})(\\d{3})(\\d{2})(\\d{2})',
                    '$1 $2 $3 $4',
                    ['[24][1-8]|3[1-9]'],
                    '(0$1)',
                    1
                ],
                ['(\\d{3})(\\d{3})(\\d{6,7})', '$1 $2 $3', ['80'], '0$1', 1]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}',
                    [10]
                ],
                ['561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}', [10]],
                ['8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})', [10, 12, 13]],
                ['(?:8[89]8|900)\\d{7}', [10]],
                ['592(?:21[12]|461)\\d{4}', [10]],
                0,
                ['444\\d{4}', [7]],
                ['512\\d{7}', [10]],
                ['850\\d{7}', [10]]
            ]
        ],
        TW: [
            '886',
            '0(?:0[25-79]|19)',
            '[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}',
            [7, 8, 9, 10, 11],
            [
                ['(\\d{2})(\\d)(\\d{4})', '$1 $2 $3', ['202'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{3,4})', '$1 $2 $3', ['[258]0'], '0$1'],
                [
                    '(\\d)(\\d{3,4})(\\d{4})',
                    '$1 $2 $3',
                    [
                        '[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]',
                        '[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]'
                    ],
                    '0$1'
                ],
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[49]'], '0$1'],
                ['(\\d{2})(\\d{4})(\\d{4,5})', '$1 $2 $3', ['7'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}',
                    [8, 9]
                ],
                ['(?:40001[0-2]|9[0-8]\\d{4})\\d{3}', [9]],
                ['80[0-79]\\d{6}|800\\d{5}', [8, 9]],
                ['20(?:[013-9]\\d\\d|2)\\d{4}', [7, 9]],
                ['99\\d{7}', [9]],
                0,
                ['50[0-46-9]\\d{6}', [9]],
                0,
                ['7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}', [10, 11]]
            ],
            0,
            '#'
        ],
        US: [
            '1',
            '011',
            '[2-9]\\d{9}|3\\d{6}',
            [10],
            [
                ['(\\d{3})(\\d{4})', '$1-$2', ['310'], 0, 1],
                ['(\\d{3})(\\d{3})(\\d{4})', '($1) $2-$3', ['[2-9]'], 0, 1, '$1-$2-$3']
            ],
            '1',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}'
                ],
                [''],
                ['8(?:00|33|44|55|66|77|88)[2-9]\\d{6}'],
                ['900[2-9]\\d{6}'],
                [
                    '52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}'
                ]
            ]
        ],
        PH: [
            '63',
            '00',
            '9(?:05[0-9]|16|17\\d|2[0-3]|35|9[0-3]|44)\\d{7}|8(?:13|17)\\d{7}|[89]\\d{9}',
            [10],
            [['(\\d{4})(\\d{3})(\\d{3})', '$1 $2 $3', ['8(?:13|17)|9'], '0$1']],
            '0',
            0,
            0,
            0,
            0,
            0,
            [['9(?:05[0-9]|16|17\\d|2[0-3]|35|9[0-3])\\d{7}|8(?:13|17)\\d{7}|[89]\\d{9}', [10]]]
        ],
        VN: [
            '84',
            '00',
            '[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}',
            [7, 8, 9, 10],
            [
                ['(\\d{2})(\\d{5})', '$1 $2', ['80'], '0$1', 1],
                ['(\\d{4})(\\d{4,6})', '$1 $2', ['1'], 0, 1],
                ['(\\d{2})(\\d{3})(\\d{2})(\\d{2})', '$1 $2 $3 $4', ['6'], '0$1', 1],
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['[357-9]'], '0$1', 1],
                ['(\\d{2})(\\d{4})(\\d{4})', '$1 $2 $3', ['2[48]'], '0$1', 1],
                ['(\\d{3})(\\d{4})(\\d{3})', '$1 $2 $3', ['2'], '0$1', 1]
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}',
                    [10]
                ],
                [
                    '(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}',
                    [9]
                ],
                ['1800\\d{4,6}|12(?:0[13]|28)\\d{4}', [8, 9, 10]],
                ['1900\\d{4,6}', [8, 9, 10]],
                0,
                0,
                ['(?:[17]99|80\\d)\\d{4}|69\\d{5,6}', [7, 8]],
                0,
                ['672\\d{6}', [9]]
            ]
        ],
        ZA: [
            '27',
            '00',
            '[1-79]\\d{8}|8\\d{4,9}',
            [5, 6, 7, 8, 9, 10],
            [
                ['(\\d{2})(\\d{3,4})', '$1 $2', ['8[1-4]'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{2,3})', '$1 $2 $3', ['8[1-4]'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{3})', '$1 $2 $3', ['860'], '0$1'],
                ['(\\d{2})(\\d{3})(\\d{4})', '$1 $2 $3', ['[1-9]'], '0$1'],
                ['(\\d{3})(\\d{3})(\\d{4})', '$1 $2 $3', ['8'], '0$1']
            ],
            '0',
            0,
            0,
            0,
            0,
            0,
            [
                [
                    '(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}',
                    [9]
                ],
                [
                    '(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}',
                    [5, 6, 7, 8, 9]
                ],
                ['80\\d{7}', [9]],
                ['(?:86[2-9]|9[0-2]\\d)\\d{6}', [9]],
                0,
                0,
                ['861\\d{6,7}', [9, 10]],
                0,
                [
                    '87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}',
                    [9]
                ],
                ['860\\d{6}', [9]]
            ]
        ]
    },
    nonGeographic: {}
} as MetadataJson;
